import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from '../_services/authentication.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {
    model: any = {};
    loading = false;
    error = '';
 
    constructor( private router: Router, private authenticationService: AuthenticationService) { 

    }
 
    ngOnInit() {
    }
    login() {
        this.loading = true;
        this.authenticationService.login(this.model.email, this.model.password)
            .subscribe( (result) => {
                        this.router.navigate(['/dashboard']);  
                }, (err) => { 
                    this.error = err;
                    this.loading = false;
                }
            );
    }

    sendEmail() {
        var link = "mailto:stig@micar.dk";
        window.location.href = link; 
    }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts